import type { AssetRiskLevel } from "@/entities/asset";

import { useTranslation } from "react-i18next";

import { capitalize } from "@/utilities/string";

import {
  ASSET_NO_RISK_VALUE,
  ASSET_RISKS_REFERENTIAL,
} from "./asset-risk.constant";

export const useAssetRisksReferential = () => {
  const { t } = useTranslation();

  const riskLevels = ASSET_RISKS_REFERENTIAL.map((risk) => ({
    ...risk,
    name: capitalize(t(`asset:risk:${risk.name}`)),
  }));

  const getRiskLevel = (risk?: AssetRiskLevel) => {
    return riskLevels.find((riskLevel) => `${riskLevel.value}` === `${risk}`);
  };

  const noRisk = riskLevels.find((risk) => risk.value === ASSET_NO_RISK_VALUE);

  return {
    riskLevels,
    getRiskLevel,
    noRisk,
  };
};
